
import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';

import { NumberInput } from '@process-advisor/process-miner/components/shared/numberInput';
import { type SpacingsProps } from '@process-advisor/process-miner/api/methods/settings/setSpacings';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
    display: flex;
`;

const StyledNumberInput = styled(NumberInput)`
    margin-right: 30px;
`;

export const Spacing: React.FC = () => {
    let [spacings, setSpacings] = React.useState<SpacingsProps>({
        layer: 0,
        column: 0,
    });

    const onChange = _.curry((key: keyof SpacingsProps, value: number) => {
        setSpacings({ ...spacings, [key]: value });
    });

    const onBlur = _.curry((key: keyof SpacingsProps, value: number) => {
        apiProvider.setSpacings(spacings)
    });

    React.useEffect(() => {
        setSpacings(apiProvider.getSpacings());
    }, []);

    React.useEffect(() => {
        const listener = () => {
            const values = apiProvider.getSpacings();
            apiProvider.setSpacings(values);
            setSpacings(values);
        };

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);


    return (
        <Wrapper>
            <StyledNumberInput
                label='Column'
                value={spacings.column}
                onChange={onChange('column')}
                onBlur={onBlur('column')}/>
            <NumberInput
                label='Layer'
                value={spacings.layer}
                onChange={onChange('layer')}
                onBlur={onBlur('layer')} />
        </Wrapper>
    );
};
